export default "__VITE_ASSET__7bb08d2c__"